import { ApiError, IApiErrorProps } from './ApiError';

export interface IModuleLoadErrorProps extends IApiErrorProps {
  chunkName?: string;
}

export class ModuleLoadError extends ApiError {
  public readonly chunkName: string | undefined;

  constructor(props: IModuleLoadErrorProps) {
    super(props);

    this.chunkName = props.chunkName;
  }
}
